"use client";
import { TBannerProps } from "@/app/actions/get-home";
import { Button, Icon } from "@/components";
import Link from "next/link";
import React from "react";
import { CitizensRotate } from "@/components/citizens-rotate";

export function Banner({
  tituloDestaque,
  titulo,
  subtitulo,
  video,
  botao
}: TBannerProps) {
  return (
    <section className="z-10 relative bg-primary bg-linear-90 from-primary to-primary-foreground bg-fixed bg-[url(/pattern-primary.svg)] rounded-b-4xl h-90 sm:h-120 md:h-120 lg:h-160 xl:h-170">
      <div className="justify-center items-center grid grid-cols-12 mx-auto px-8 h-full container">
        <div className="flex flex-col justify-start items-start gap-8 col-span-12 lg:col-span-4  mt-20 lg:mt-20 w-full z-10">
          <h1 className="drop-shadow-md font-black text-white text-4xl sm:text-6xl md:text-7xl lg:text-7xl xl:text-9xl leading-6 sm:leading-8 md:leading-10 lg:leading-10 xl:leading-14">
            {tituloDestaque}
            {tituloDestaque.length > 0 && <br />}
            <span className="w-60 sm:w-80 xl:w-100 flex font-medium text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl">
              {titulo}
            </span>
          </h1>
          <p className="w-40 sm:w-80 xl:w-100 flex font-medium text-input text-sm sm:text-lg xl:text-3xl">
            {subtitulo}
          </p>
          <Link href={botao.url}>
            <Button
              variant="white"
              size="lg"
              className="group xl:pr-6 overflow-hidden"
            >
              {botao.titulo}{" "}
              <Icon
                icon="FaArrowRight"
                className="group-hover:mr-0  transition-all duration-300"
              />
            </Button>
          </Link>
        </div>
        <div className="hidden lg:flex col-span-8 relative h-full justify-end items-center">
          <iframe width="560" height="315" src={video} title="Vídeo no YouTube sobre a participação cidadã" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen className="rounded-2xl xl:w-[810px] xl:h-[455px]" />
        </div>
        <CitizensRotate className="right-0 lg:hidden lg:right-0 bottom-0 absolute w-8/12 lg:w-6/12 xl:w-5/12 max-h-full object-cover" />
      </div>
    </section>
  );
}
